/* eslint-disable import/prefer-default-export */
import { ApolloCache } from '@apollo/client'
import { isEmpty } from 'lodash'

import { PaginatedReleaseNotesCacheObj } from '../../types'
import { filterReleaseNote } from './utils'

import { PaginatedReleaseNotesQueryVariables, ReleaseNoteFragment } from '~generated/operations'
import { wrapQueryModifier } from '~lib/apollo/helpers'

export function addReleaseNotesToPaginatedQuery(cache: ApolloCache<any>, releaseNotes: ReleaseNoteFragment[]) {
  cache.modify({
    fields: {
      paginatedReleaseNotes: wrapQueryModifier<PaginatedReleaseNotesCacheObj, PaginatedReleaseNotesQueryVariables>(
        (query, { variables, toReference }) => {
          const newRelevantReleaseNotes = filterReleaseNote({
            items: releaseNotes,
            filter: variables.filter,
          })

          if (isEmpty(newRelevantReleaseNotes)) {
            return query
          }

          const newDocs = newRelevantReleaseNotes.map((item) => toReference(item))
          const docs = [...newDocs, ...query.docs]
          const totalDocs = query.totalDocs + newDocs.length
          const totalPages = Math.ceil(totalDocs / query.limit)
          const page = Math.floor(docs.length / query.limit) || 1

          return {
            ...query,
            docs,
            page,
            totalPages,
            totalDocs,
          }
        }
      ),
    },
  })
}
